import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import starIcon from "../../assets/star_icon.svg";
import { getUserListThunk } from "../../slices/artists/thunk";
import { 
  createParticipateContestThunk as onCreateParticipateContestThunk, 
  resetContestThunk as onResetContest 
} from "../../slices/contest/thunk";

const RecommendedArtist = ({ contestId }) => {
  const dispatch = useDispatch();
  const [loadingArtistId, setLoadingArtistId] = useState(null);

  const selectArtistState = (state) => state.user;
  const artistSelector = createSelector(selectArtistState, (artist) => ({
    isLoading: artist.isLoading,
    users: artist.users,
  }));

  const { users } = useSelector(artistSelector);
  const fileUrl = process.env.REACT_APP_FILE_URL;

  //isParticipate
  const selectContestState = (state) => state.contest;
  const contestSelector = createSelector(selectContestState, (contest) => ({
    isParticipate: contest.isParticipate,
  }));

    const { isParticipate } = useSelector(contestSelector);

  useEffect(() => {
    if (contestId) {
      dispatch(getUserListThunk({ userType: 2, contest_id: contestId,isInHouseArtist:2 }));
    }
  }, [dispatch, contestId, isParticipate]);

  useEffect(() => {
    
    if (isParticipate) {
      setLoadingArtistId(null);
    }
  }, [isParticipate]);

  const handleHireArtist = (artistId) => {
    setLoadingArtistId(artistId);
    dispatch(onResetContest());
    dispatch(onCreateParticipateContestThunk({'contestId':contestId, 'artistId':artistId,'is_accept':3,'is_user_request':1}));
  };

  // Determine if any artist is hired or requested (to disable others)
  const hasHiredOrRequested = users?.some(
    (u) => u.participateInContest == 1 || u.participateInContest == 3
  );

  return (
    <>
      <h2 className="text-start text-black text-[20px] font-bold font-grotesk mb-4">
        Recommended Artists
      </h2>

      <div className="w-full rounded-[14px] py-3 px-3 sm:px-[15px] ">
        
        {users?.map((user) => {
          const profilePic = user.image ? `${fileUrl}/${user.image}` : null;
          const status = user.participateInContest;
          let buttonLabel = "Hire";
          let isDisabled = false;
          let buttonStyle = "bg-transparent border border-secondary text-secondary";

          switch (status) {
            case 1:
              buttonLabel = "Hired";
              isDisabled = true;
              buttonStyle = "bg-secondary text-white";
              break;
            case 2:
              buttonLabel = "Rejected";
              isDisabled = true;
              buttonStyle = "bg-transparent text-red-500 border border-red-500";
              break;
            case 3:
              buttonLabel = "Requested";
              isDisabled = true;
              buttonStyle = "bg-transparent text-primary border border-primary ";
              break;
            default:
              buttonLabel = "Get Hire";
              isDisabled = hasHiredOrRequested; // disable if another artist is hired/requested
              buttonStyle = "bg-transparent border border-border_color text-secondary";
          }

          return (
            <div key={user.id} className="w-full">
              <div className="w-full flex items-center justify-between">
                {/* Left Side */}
                <div className="flex items-center gap-2">
                  <div className="w-[50px] h-[50px] sm:w-[69px] sm:h-[69px] p-[2px] border-2 border-secondary rounded-full flex items-center justify-center overflow-hidden">
                      <img
                        src={profilePic}
                        alt="Profile"
                        className="w-full h-full object-cover rounded-full"
                      />
                  </div>
                  <div>
                    <div className="flex items-center gap-1 sm:gap-2 flex-wrap">
                      <p className="text-[12px] sm:text-[16px] text-black font-bold font-grotesk">
                        {user.name}
                      </p>
                      <span className="hidden xs:block">
                        <img src={starIcon} alt="Star" />
                      </span>
                    </div>
                    <p className="text-[10px] sm:text-sm text-secondary font-bold font-grotesk ">
                      {user.skill?.[0] || " "}
                    </p>
                  </div>
                </div>

                {/* Right Side */}
                <div>
                  <button
                    disabled={isDisabled || loadingArtistId === user.withoutEncryptId}
                    onClick={() => handleHireArtist(user.withoutEncryptId)}
                    className={`min-w-[70px] sm:min-w-[95px] py-3 text-sm font-bold px-2 sm:px-5 font-grotesk rounded-[10px] tracking-wide hover:opacity-90 transition duration-300 whitespace-nowrap ${buttonStyle} relative flex items-center justify-center `}
                  >
                    {loadingArtistId === user.withoutEncryptId ? (
                      <div className="flex items-center justify-center">
                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </div>
                    ) : (
                      buttonLabel
                    )}
                  </button>
                </div>
              </div>
              <hr className="mt-4 mb-4" />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default RecommendedArtist;
